import { gql } from "@apollo/client";

// Subscripción que se activa cuando se recibe un nuevo mensaje de la ETD
export const OnLastOfflineDevices = gql`
    subscription OnLastOfflineDevices{
        its_offline_devices(
            order_by: {created_at: desc}, 
            limit: 1,
        ) {
            id
            device_type
            description
            created_at
            is_online
        }
    }
`;
